export const VIEWED_WALKTHROUGH_STEP = 'Viewed Walkthrough Step';
export const DISMISSED_WALKTHROUGH = 'Dismissed Walkthrough';
